import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { t } from '~/components/I18n/i18n';

export const useDefaultErrorHandler = () =>
  useCallback(() => {
    toast(t('citizen_error_etc_desc'));
  }, []);
